import axios from "axios";

const getUserById = async (token, userId) => {
  const path = `${process.env.REACT_APP_BACKEND_API_URL}/users/${userId}`;

  try {
    const response = await axios.get(path, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
    // console.log(response);
    return response;
  } catch (error) {
    console.log(error.response);
    return error.response;
  } 
};

export default getUserById;